import { DateTime } from "luxon";
import { RecalledValue } from "./RecalledValue";
import { RecallType } from "./RecallType";
import { cDateFormatToLuxon, EPOCH } from "../utils/time";

export class DateTimeRecalledValue extends RecalledValue {
    time: DateTime;

    constructor(date: DateTime) {
        super();
        this.time = date;
    }

    evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue {
        switch (property) {
            case "code":
                return this.toCode();
            case "text":
                return this.toText();
            case "year":
                if (this.time == null) return "";
                return this.time.toFormat("y");
            case "month":
                if (this.time == null) return "";
                return this.time.toFormat("MMMM");
            case "day":
                if (this.time == null) return "";
                return this.time.day.toString();
            case "hour":
                if (this.time == null) return "";
                return this.time.toFormat("H");
            case "minute":
                if (this.time == null) return "";
                return this.time.toFormat("m");
            case "second":
                if (this.time == null) return "";
                return this.time.toFormat("s");
            case "value":
                if (this.time == null) return "";
                return this.time.toFormat("FFF");
            case "format":
                if (this.time == null) return "";
                return this.time.toFormat(cDateFormatToLuxon(parameters[0]));
            case "answer":
                return this.time.toString();
            default:
                return this;
        }
    }

    toCode(): string {
        if (this.time == null) return "";
        return this.time.diff(EPOCH, "seconds").toString();
    }

    toText(): string {
        if (this.time == null) return "";
        return this.time.toFormat("FFF");
    }
}
